import { renderPagination } from '../../../components/Pagination/pagination.js';

(() => {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.blog-story-grid').forEach(block => {

      //////////////////////////////////////
      // DOM REFS
      const grid           = block.querySelector('.grid');
      const cards          = Array.from(block.querySelectorAll('.card'));
      const paginationEl   = block.querySelector('.pagination');
      const categorySelect = block.querySelector('.category-filter select');
      const typeSelect     = block.querySelector('.type-filter select');
      const sortSelect     = block.querySelector('.sort-filter select');
      const noResults      = block.querySelector('.no-results');
      const resetBtns      = block.querySelectorAll('.reset');
      const perPage        = parseInt(block.dataset.perPage, 10) || 3;
      const PARAMS         = { category: 'category_filter', type: 'type_filter', sort: 'sort' };

      if (!cards.length) return;


      //////////////////////////////////////
      // STATE
      // sort: '' = newest first (server order), 'oldest', 'title', 'title-desc'
      const state = { page: 1, category: '', type: '', sort: '' };


      //////////////////////////////////////
      // HELPERS
      // Only accept values that exist in the dropdown — anything else falls back to the default
      const validOption = (select, value) => {
        if (!value || !select) return '';
        return Array.from(select.options).some(opt => opt.value === value) ? value : '';
      };

      const readUrl = () => {
        const params   = new URLSearchParams(window.location.search);
        state.category = validOption(categorySelect, params.get(PARAMS.category));
        state.type     = validOption(typeSelect, params.get(PARAMS.type));
        state.sort     = validOption(sortSelect, params.get(PARAMS.sort));
        state.page     = 1;
        if (categorySelect) categorySelect.value = state.category;
        if (typeSelect) typeSelect.value = state.type;
        if (sortSelect) sortSelect.value = state.sort;
      };

      const writeUrl = () => {
        const url = new URL(window.location.href);
        Object.entries(PARAMS).forEach(([key, param]) => {
          if (state[key]) url.searchParams.set(param, state[key]);
          else url.searchParams.delete(param);
        });
        history.pushState(null, '', url);
      };

      const hasTerm = (list, slug) => !slug || (list || '').split(' ').includes(slug);

      const matches = (card) => hasTerm(card.dataset.categories, state.category) && hasTerm(card.dataset.types, state.type);

      const byTitle = (a, b) => a.dataset.title.localeCompare(b.dataset.title, undefined, { sensitivity: 'base', numeric: true });

      const sorters = {
        '':           (a, b) => b.dataset.date - a.dataset.date,
        oldest:       (a, b) => a.dataset.date - b.dataset.date,
        title:        (a, b) => byTitle(a, b),
        'title-desc': (a, b) => byTitle(b, a),
      };


      //////////////////////////////////////
      // RENDER
      const render = () => {
        // reorder the DOM so the grid reads in sort order
        cards.slice().sort(sorters[state.sort]).forEach(card => grid.appendChild(card));

        const visible = Array.from(grid.children).filter(matches);
        const start   = (state.page - 1) * perPage;
        const end     = start + perPage;

        cards.forEach(card => { card.style.display = 'none'; });
        visible.forEach((card, i) => {
          if (i >= start && i < end) card.style.display = '';
        });

        // empty state replaces the pagination when nothing matches
        if (noResults) noResults.style.display = visible.length ? 'none' : '';
        paginationEl.style.display = visible.length ? '' : 'none';

        renderPagination({
          container:   paginationEl,
          currentPage: state.page,
          totalItems:  visible.length,
          perPage,
          label:       'Posts',
          onPageChange(page) { state.page = page; render(); }
        });
      };


      //////////////////////////////////////
      // FILTER + SORT
      if (categorySelect) {
        categorySelect.addEventListener('change', () => {
          state.category = validOption(categorySelect, categorySelect.value);
          state.page     = 1;
          writeUrl();
          render();
        });
      }

      if (typeSelect) {
        typeSelect.addEventListener('change', () => {
          state.type = validOption(typeSelect, typeSelect.value);
          state.page = 1;
          writeUrl();
          render();
        });
      }

      if (sortSelect) {
        sortSelect.addEventListener('change', () => {
          state.sort = validOption(sortSelect, sortSelect.value);
          state.page = 1;
          writeUrl();
          render();
        });
      }

      resetBtns.forEach(resetBtn => {
        resetBtn.addEventListener('click', () => {
          state.category = '';
          state.type     = '';
          state.sort     = '';
          state.page     = 1;
          if (categorySelect) categorySelect.value = '';
          if (typeSelect) typeSelect.value = '';
          if (sortSelect) sortSelect.value = '';
          writeUrl();
          render();
        });
      });

      // Back/forward restores the filters + sort from the URL
      window.addEventListener('popstate', () => {
        readUrl();
        render();
      });


      //////////////////////////////////////
      // INIT
      readUrl();
      render();

    });

  });

})();
